interface AcademyTeamInfo {
    key: number;
    year: number;
    graduated?: boolean;
}

const ACADEMY_YEARS: AcademyTeamInfo[] = [
        {
            key: 1,
            year: 2000,
            graduated: true,
        },
        {
            key: 2,
            year: 2001,
            graduated: true,
        },
        {
            key: 3,
            year: 2002,
            graduated: true,
        },
        {
            key: 4,
            year: 2003,
            graduated: true,
        },
        {
            key: 5,
            year: 2004,
            graduated: true,
        },
        {
            key: 6,
            year: 2005,
            graduated: true,
        },
        {
            key: 7,
            year: 2006,
            graduated: true,
        },
        {
            key: 8,
            year: 2007,
            graduated: true,
        },
        {
            key: 9,
            year: 2008,
            graduated: true,
        },
        {
            key: 10,
            year: 2009,
        },
        {
            key: 11,
            year: 2010,
        },
        {
            key: 13,
            year: 2011,
        },
        {
            key: 15,
            year: 2012,
        },
        {
            key: 16,
            year: 2013,
        },
        {
            key: 17,
            year: 2014,
        },
        {
            key: 18,
            year: 2015,
        },
        {
            key: 19,
            year: 2016,
        },
        {
            key: 20,
            year: 2017,
        },
    ];

export const getTeamByYear = (year: number): AcademyTeamInfo | null => {
    if (!year) return null;

    return ACADEMY_YEARS.find(n => n.year === year);
};

export const getTeamById = (teamId: number): AcademyTeamInfo | null => {
    if (!teamId) return null;

    return ACADEMY_YEARS.find(n => n.key === teamId);
};


export const getAcademyTeamByYear = (year: number) => {
    return getTeamByYear(year)?.key || 0;
};

export const getAcademyYearByTeam = (team: string) => {
    return getTeamById(+team)?.year || 0;
};
